import { RSAA } from 'redux-api-middleware';

import {
  GET_INSTANCES_REQUESTED,
  GET_INSTANCES_POLL,
  GET_INSTANCES_FAILURE,
  GET_INSTANCES_SUCCESS,
  GET_INSTANCE_REQUESTED,
  GET_INSTANCE_POLL,
  GET_INSTANCE_FAILURE,
  GET_INSTANCE_SUCCESS,
  GET_INSTANCE_WITH_PASSWORD_REQUESTED,
  GET_INSTANCE_WITH_PASSWORD_SUCCESS,
  GET_INSTANCE_WITH_PASSWORD_FAILURE,
  ADD_INSTANCE_ACL_REQUESTED,
  ADD_INSTANCE_ACL_FAILURE,
  ADD_INSTANCE_ACL_SUCCESS,
  DELETE_INSTANCE_ACL_REQUESTED,
  DELETE_INSTANCE_ACL_FAILURE,
  DELETE_INSTANCE_ACL_SUCCESS,
  DELETE_INSTANCE_REQUESTED,
  DELETE_INSTANCE_FAILURE,
  DELETE_INSTANCE_SUCCESS,
  GET_INSTANCE_USERS_REQUESTED,
  GET_INSTANCE_USERS_SUCCESS,
  GET_INSTANCE_USERS_FAILURE,
  DELETE_INSTANCE_USER_REQUESTED,
  DELETE_INSTANCE_USER_FAILURE,
  DELETE_INSTANCE_USER_SUCCESS,
  RESET_INSTANCE_ERROR_STATE,
  ADD_INSTANCE_USER_REQUESTED,
  ADD_INSTANCE_USER_FAILURE,
  ADD_INSTANCE_USER_SUCCESS,
  GET_INSTANCE_DATABASES_REQUESTED,
  GET_INSTANCE_DATABASES_FAILURE,
  GET_INSTANCE_DATABASES_SUCCESS,
  ADD_INSTANCE_DATABASE_REQUESTED,
  ADD_INSTANCE_DATABASE_FAILURE,
  ADD_INSTANCE_DATABASE_SUCCESS,
  DELETE_INSTANCE_DATABASE_REQUESTED,
  DELETE_INSTANCE_DATABASE_FAILURE,
  DELETE_INSTANCE_DATABASE_SUCCESS,
  GET_SPACEUSAGE_REQUESTED,
  GET_SPACEUSAGE_SUCCESS,
  GET_SPACEUSAGE_FAILURE,
  GET_INSTANCE_CERTIFICATES_REQUESTED,
  GET_INSTANCE_CERTIFICATES_FAILURE,
  GET_INSTANCE_CERTIFICATES_SUCCESS,
  GET_INSTANCE_CLIENT_CERTIFICATES_REQUESTED,
  GET_INSTANCE_CLIENT_CERTIFICATES_FAILURE,
  GET_INSTANCE_CLIENT_CERTIFICATES_SUCCESS,
  GET_INSTANCE_CERTIFICATE_DOWNLOAD_REQUESTED,
  GET_INSTANCE_CERTIFICATE_DOWNLOAD_FAILURE,
  GET_INSTANCE_CERTIFICATE_DOWNLOAD_SUCCESS,
  CREATE_INSTANCE_CERTIFICATE_REQUESTED,
  CREATE_INSTANCE_CERTIFICATE_FAILURE,
  CREATE_INSTANCE_CERTIFICATE_SUCCESS,
  CREATE_INSTANCE_CLIENT_CERTIFICATE_REQUESTED,
  CREATE_INSTANCE_CLIENT_CERTIFICATE_FAILURE,
  CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS,
  DELETE_INSTANCE_CERTIFICATE_REQUESTED,
  DELETE_INSTANCE_CERTIFICATE_FAILURE,
  DELETE_INSTANCE_CERTIFICATE_SUCCESS,
  GET_PITR_BACKUP_REQUESTED,
  GET_PITR_BACKUP_FAILURE,
  GET_PITR_BACKUP_SUCCESS,
  GET_BACKUPS_REQUESTED,
  GET_BACKUPS_FAILURE,
  GET_BACKUPS_SUCCESS,
  PATCH_CONFIG_REQUESTED,
  PATCH_CONFIG_FAILURE,
  PATCH_CONFIG_SUCCESS,
  CHANGE_NODE_QUANTITY_REQUESTED,
  CHANGE_NODE_QUANTITY_FAILURE,
  CHANGE_NODE_QUANTITY_SUCCESS,
} from '../actions';

const getInstancesActionSet = () => ({
  [RSAA]: {
    types: [GET_INSTANCES_REQUESTED, GET_INSTANCES_SUCCESS, GET_INSTANCES_FAILURE],
    method: 'GET',
    endpoint: '/instanceslist/',
  },
});

/**
 * Retrieves a list of instances
 */
export const getInstances = () => (dispatch) => dispatch(getInstancesActionSet());

const getInstancesPollActionSet = () => ({
  [RSAA]: {
    types: [GET_INSTANCES_POLL, GET_INSTANCES_SUCCESS, GET_INSTANCES_FAILURE],
    method: 'GET',
    endpoint: '/instanceslist/',
  },
});

/**
 * Retrieves a list of instances without setting is load
 */
export const getInstancesPoll = () => (dispatch) => dispatch(getInstancesPollActionSet());

const getInstancePollActionSet = (id, service) => ({
  [RSAA]: {
    types: [GET_INSTANCE_POLL, GET_INSTANCE_SUCCESS, GET_INSTANCE_FAILURE],
    method: 'GET',
    endpoint: `/instances/${service}/${id}/`,
  },
});

/**
 * Retrieves an instance without setting is load
 */
export const getInstancePoll = (id, service) => (dispatch) =>
  dispatch(getInstancePollActionSet(id, service));

const getInstanceActionSet = (id, service) => ({
  [RSAA]: {
    types: [GET_INSTANCE_REQUESTED, GET_INSTANCE_SUCCESS, GET_INSTANCE_FAILURE],
    method: 'GET',
    endpoint: `/instances/${service.toLowerCase()}/${id}/`,
  },
});

/**
 * Retrieves an instance. This is necessary in case someone bookmarks
 * a link to an instance details page.
 */
export const getInstance = (id, service) => (dispatch) =>
  dispatch(getInstanceActionSet(id, service));

const getInstanceWithPasswordActionSet = (id, service, showPassword) => ({
  [RSAA]: {
    types: [
      GET_INSTANCE_WITH_PASSWORD_REQUESTED,
      GET_INSTANCE_WITH_PASSWORD_SUCCESS,
      GET_INSTANCE_WITH_PASSWORD_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service.toLowerCase()}/${id}/?showPassword=${showPassword}`,
  },
});

/**
 * Retrieves an instance with password shown in the connection string.
 */
export const getInstanceWithPassword = (id, service, showPassword = false) => (dispatch) =>
  dispatch(getInstanceWithPasswordActionSet(id, service, showPassword));

const addInstanceAclActionSet = (id, service, data) => ({
  [RSAA]: {
    types: [
      ADD_INSTANCE_ACL_REQUESTED,
      { type: ADD_INSTANCE_ACL_SUCCESS, meta: { data, id } },
      ADD_INSTANCE_ACL_FAILURE,
    ],
    method: 'POST',
    endpoint: `/instances/${service.toLowerCase()}/${id}/acls/`,
    body: JSON.stringify(data),
  },
});

/**
 * Adds an ACL to an existing instance
 */
export const addInstanceAcl = (id, service, data) => (dispatch) =>
  dispatch(addInstanceAclActionSet(id, service, data));

const deleteInstanceAclActionSet = (service, instanceId, aclId) => ({
  [RSAA]: {
    types: [
      DELETE_INSTANCE_ACL_REQUESTED,
      { type: DELETE_INSTANCE_ACL_SUCCESS, meta: { instanceId, aclId } },
      DELETE_INSTANCE_ACL_FAILURE,
    ],
    method: 'DELETE',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/acls/${aclId}/`,
  },
});

/**
 * Deletes an ACL from an existing instance
 */
export const deleteInstanceAcl = (service, instanceId, aclId) => (dispatch) =>
  dispatch(deleteInstanceAclActionSet(service, instanceId, aclId));

const deleteInstanceActionSet = (id, service) => ({
  [RSAA]: {
    types: [DELETE_INSTANCE_REQUESTED, DELETE_INSTANCE_SUCCESS, DELETE_INSTANCE_FAILURE],
    method: 'DELETE',
    endpoint: `/instances/${service}/${id}/`,
  },
});

/**
 * Requests an instance to be deleted
 */
export const deleteInstance = (id, service, redirect) => (dispatch) =>
  dispatch(deleteInstanceActionSet(id, service, redirect)).then((response) => {
    if (response.type === DELETE_INSTANCE_SUCCESS) {
      redirect();
    }
  });

const getInstanceUsersSet = (id, service) => ({
  [RSAA]: {
    types: [
      GET_INSTANCE_USERS_REQUESTED,
      { type: GET_INSTANCE_USERS_SUCCESS, meta: { id } },
      GET_INSTANCE_USERS_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service}/${id}/users/`,
  },
});

/**
 * Requests the users for an instance
 */
export const getInstanceUsers = (id, service) => (dispatch) => {
  dispatch(getInstanceUsersSet(id, service));
};

const deleteInstanceUserSet = (instanceId, service, userName, dataBase) => {
  const payload = { username: userName };

  if (dataBase) {
    payload.database = dataBase;
  }

  return {
    [RSAA]: {
      types: [
        DELETE_INSTANCE_USER_REQUESTED,
        { type: DELETE_INSTANCE_USER_SUCCESS, meta: { instanceId, userName } },
        DELETE_INSTANCE_USER_FAILURE,
      ],
      method: 'DELETE',
      endpoint: `/instances/${service}/${instanceId}/users/`,
      body: JSON.stringify({
        ...payload,
      }),
    },
  };
};

/**
 * Deletes a user for an instance
 */
export const deleteInstanceUser = (instanceId, service, userId, database) => (dispatch) => {
  dispatch(deleteInstanceUserSet(instanceId, service, userId, database));
};

const resetInstanceErrorStateActionSet = () => ({
  type: RESET_INSTANCE_ERROR_STATE,
  payload: null,
});

export const resetInstanceErrorState = () => (dispatch) =>
  dispatch(resetInstanceErrorStateActionSet());

const addInstanceUserActionSet = (instanceId, service, data) => ({
  [RSAA]: {
    types: [
      ADD_INSTANCE_USER_REQUESTED,
      { type: ADD_INSTANCE_USER_SUCCESS, meta: { data, instanceId } },
      ADD_INSTANCE_USER_FAILURE,
    ],
    method: 'POST',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/users/`,
    body: JSON.stringify(data),
  },
});

/**
 * Adds a user to an existing instance
 */
export const addInstanceUser = (instanceId, service, data) => (dispatch) =>
  dispatch(addInstanceUserActionSet(instanceId, service, data));

const pullInstanceDatabasesActionSet = (instanceId, service) => ({
  [RSAA]: {
    types: [
      GET_INSTANCE_DATABASES_REQUESTED,
      { type: GET_INSTANCE_DATABASES_SUCCESS, meta: { instanceId } },
      GET_INSTANCE_DATABASES_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/databases/`,
  },
});

/**
 * Gets databases related to an instance
 */

export const pullInstanceDatabases = (instanceId, service) => (dispatch) =>
  dispatch(pullInstanceDatabasesActionSet(instanceId, service));

const addInstanceDatabaseActionSet = (instanceId, service, data) => ({
  [RSAA]: {
    types: [
      ADD_INSTANCE_DATABASE_REQUESTED,
      { type: ADD_INSTANCE_DATABASE_SUCCESS, meta: { data, instanceId } },
      ADD_INSTANCE_DATABASE_FAILURE,
    ],
    method: 'POST',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/databases/`,
    body: JSON.stringify({
      name: data.name,
    }),
  },
});

/**
 * Adds a database to an instance
 */
export const addInstanceDatabase = (instanceId, service, data) => (dispatch) =>
  dispatch(addInstanceDatabaseActionSet(instanceId, service, data));

const deleteInstanceDatabaseActionSet = (instanceId, service, name) => ({
  [RSAA]: {
    types: [
      DELETE_INSTANCE_DATABASE_REQUESTED,
      { type: DELETE_INSTANCE_DATABASE_SUCCESS, meta: { instanceId, name } },
      DELETE_INSTANCE_DATABASE_FAILURE,
    ],
    method: 'DELETE',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/databases/${name}/`,
  },
});

/**
 * Deletes a database from an instance
 */
export const deleteInstanceDatabase = (instanceId, service, name) => (dispatch) =>
  dispatch(deleteInstanceDatabaseActionSet(instanceId, service, name));

const getSpaceUsageActionSet = (instanceId) => ({
  [RSAA]: {
    types: [
      GET_SPACEUSAGE_REQUESTED,
      { type: GET_SPACEUSAGE_SUCCESS, meta: { instanceId } },
      GET_SPACEUSAGE_FAILURE,
    ],
    method: 'GET',
    endpoint: `/stats/instances/${instanceId}/spaceusage/`,
  },
});

/**
 * Gets space usage stats for an instance
 */
export const getSpaceUsage = (instanceId) => (dispatch) =>
  dispatch(getSpaceUsageActionSet(instanceId));

const getInstanceCertificatesActionSet = (service, instanceId) => ({
  [RSAA]: {
    types: [
      GET_INSTANCE_CERTIFICATES_REQUESTED,
      { type: GET_INSTANCE_CERTIFICATES_SUCCESS, meta: { instanceId } },
      GET_INSTANCE_CERTIFICATES_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/certificates/?type=intermediate`,
  },
});

export const getInstanceCertificates = (service, instanceId) => (dispatch) =>
  dispatch(getInstanceCertificatesActionSet(service, instanceId));

const getInstanceClientCertificatesActionSet = (service, instanceId) => ({
  [RSAA]: {
    types: [
      GET_INSTANCE_CLIENT_CERTIFICATES_REQUESTED,
      { type: GET_INSTANCE_CLIENT_CERTIFICATES_SUCCESS, meta: { instanceId } },
      GET_INSTANCE_CLIENT_CERTIFICATES_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/certificates/?type=client`,
  },
});

export const getInstanceClientCertificates = (service, instanceId) => (dispatch) =>
  dispatch(getInstanceClientCertificatesActionSet(service, instanceId));

const getInstanceCertificateDownloadActionSet = (service, instanceId, CACertId) => ({
  [RSAA]: {
    types: [
      GET_INSTANCE_CERTIFICATE_DOWNLOAD_REQUESTED,
      GET_INSTANCE_CERTIFICATE_DOWNLOAD_SUCCESS,
      GET_INSTANCE_CERTIFICATE_DOWNLOAD_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service}/${instanceId}/certificates/${CACertId}/?type=intermediate&download=true`,
  },
});

/**
 * Gets CA for an instance for users to download
 */
export const getInstanceCertificateDownload = (service, instanceId, CACertId) => (dispatch) =>
  dispatch(getInstanceCertificateDownloadActionSet(service, instanceId, CACertId));

const createInstanceCertificateActionSet = (service, instanceId) => ({
  [RSAA]: {
    types: [
      CREATE_INSTANCE_CERTIFICATE_REQUESTED,
      CREATE_INSTANCE_CERTIFICATE_SUCCESS,
      CREATE_INSTANCE_CERTIFICATE_FAILURE,
    ],
    method: 'POST',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/certificates/`,
    body: JSON.stringify({
      cert_type: 'intermediate',
    }),
  },
});

/**
 * Creates primary CA
 */
export const createInstanceCertificate = (service, instanceId, cb) => (dispatch) =>
  dispatch(createInstanceCertificateActionSet(service, instanceId)).then((response) => {
    if (response.type === CREATE_INSTANCE_CERTIFICATE_SUCCESS) {
      cb();
    }
  });

const createInstanceClientCertificateActionSet = (service, instanceId, csr) => {
  const stringifiedJSON = JSON.stringify({
    cert_type: 'client',
    certificate_signing_request: csr,
  });

  const formattedBody = stringifiedJSON.replace(new RegExp('NEWLINE', 'g'), '\\n');
  return {
    [RSAA]: {
      types: [
        CREATE_INSTANCE_CLIENT_CERTIFICATE_REQUESTED,
        CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS,
        CREATE_INSTANCE_CLIENT_CERTIFICATE_FAILURE,
      ],
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      endpoint: `/instances/${service.toLowerCase()}/${instanceId}/certificates/`,
      body: formattedBody,
    },
  };
};

/**
 * Creates client certificate
 */
export const createInstanceClientCertificate = (service, instanceId, csr, cb) => (dispatch) =>
  dispatch(createInstanceClientCertificateActionSet(service, instanceId, csr)).then((response) => {
    if (response.type === CREATE_INSTANCE_CLIENT_CERTIFICATE_SUCCESS) {
      cb();
    }
  });

const deleteInstanceCertificateActionSet = (service, instanceId) => ({
  [RSAA]: {
    types: [
      DELETE_INSTANCE_CERTIFICATE_REQUESTED,
      { type: DELETE_INSTANCE_CERTIFICATE_SUCCESS, meta: { instanceId } },
      DELETE_INSTANCE_CERTIFICATE_FAILURE,
    ],
    method: 'DELETE',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/certificates/`,
    body: JSON.stringify({
      cert_type: 'intermediate',
    }),
  },
});

/**
 * Deletes primary certificate
 */
export const deleteInstanceCertificate = (service, instanceId, cb) => (dispatch) =>
  dispatch(deleteInstanceCertificateActionSet(service, instanceId)).then((response) => {
    if (response.type === DELETE_INSTANCE_CERTIFICATE_SUCCESS) {
      cb();
    }
  });

const getBackupsActionSet = (instanceId, service) => ({
  [RSAA]: {
    types: [
      GET_BACKUPS_REQUESTED,
      { type: GET_BACKUPS_SUCCESS, meta: { instanceId } },
      GET_BACKUPS_FAILURE,
    ],
    method: 'GET',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/backups/`,
  },
});

/**
 * Gets instance backups
 */
export const getBackups = (instanceId, service) => (dispatch) =>
  dispatch(getBackupsActionSet(instanceId, service));

  const getPitrBackupStatusActionSet = (instanceId, service) => ({
    [RSAA]: {
      types: [ 
        GET_PITR_BACKUP_REQUESTED,
        { type: GET_PITR_BACKUP_SUCCESS, meta: { instanceId } },
        GET_PITR_BACKUP_FAILURE 
      ],
      method: 'GET',
      endpoint: `/instances/${service.toLowerCase()}/${instanceId}/pitr-backup-status/`,
    },
  });
  
  /**
   * Gets PITR backup info
   */
  
  export const getPitrBackupStatus = (instanceId, service) => (dispatch) =>
    dispatch(getPitrBackupStatusActionSet(instanceId, service));

const setInstanceConfigurationActionSet = (instanceId, service, data) => ({
  [RSAA]: {
    types: [PATCH_CONFIG_REQUESTED, PATCH_CONFIG_SUCCESS, PATCH_CONFIG_FAILURE],
    method: 'PATCH',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/`,
    body: JSON.stringify(data),
  },
});

export const setInstanceConfiguration = (instanceId, service, data) => (dispatch) =>
  dispatch(setInstanceConfigurationActionSet(instanceId, service, data));

const changeNodeQuantityActionSet = (service, instanceId, nodeQuantityData) => ({
  [RSAA]: {
    types: [
      { type: CHANGE_NODE_QUANTITY_REQUESTED, meta: { instanceId } },
      { type: CHANGE_NODE_QUANTITY_SUCCESS, meta: { instanceId } },
      { type: CHANGE_NODE_QUANTITY_FAILURE, meta: { instanceId } },
    ],
    method: 'POST',
    endpoint: `/instances/${service.toLowerCase()}/${instanceId}/scale/`,
    body: nodeQuantityData,
  },
});

export const changeNodeQuantity = (service, instanceId, nodeQuantityData) => (dispatch) =>
  dispatch(changeNodeQuantityActionSet(service, instanceId, nodeQuantityData));
